import * as React from 'react';
import PageHeader from 'components/common/PageHeader';
import * as constants from '../../store/constants'; 
import SuperAdminDashboard from './superAdmin'; 
import AdjusterDashboard from './adjuster'; 
import PayrollDashboard from './payroll'; 
import { userHasPermission } from '../../utils/helpers';
import * as helpers from '../../utils/helpers'; 
import { USER_PERMISSIONS } from 'store/enums';
import { goto } from 'services/router-service';
import services from 'services';
import { FaExternalLinkAlt, FaChartBar } from 'react-icons/fa';
import { Button, Card, CardBody } from 'reactstrap';
import { request } from 'services/api/base';

interface Props {
}

interface State {
    activeTab: string,
    dashboards: string[], 
}

interface Params {
}

class Dashboard extends React.PureComponent<Props, State> {
    public state = {
        activeTab: "",
        dashboards: new Array<string>, 
    }    

    public handleTabs = (name: string) => {
        this.setState({ activeTab: name });
    };

    public componentDidMount(): void {
        const userInfo = helpers.getUserInfo(); 
        const userRoles = userInfo?.roles ;

        if(!userRoles) {
            localStorage.clear(); 
            goto(services.router.url.logout); 
        }
        else {
            const isAdmin = userRoles.includes("Super Admin");
            const adjScorecard = userHasPermission(USER_PERMISSIONS.ADJ_SCORECARD_ADMIN) || userHasPermission(USER_PERMISSIONS.ADJ_SCORECARD_READ);
            let allDashboards = constants.ROLE_BASED_DASHBOARDS; 
            if(userHasPermission(USER_PERMISSIONS.PAYROLL_CAN_ACCESS) || isAdmin)
                if(!allDashboards.includes("Payroll"))
                    allDashboards.push("Payroll");             
            if(adjScorecard && !allDashboards.includes("Adjuster Scorecard")) {
                allDashboards.push("Adjuster Scorecard");
            }
            const tabs = isAdmin ? allDashboards : userInfo?.roles.filter(x => constants.ROLE_BASED_DASHBOARDS.includes(x)) || [];
            this.setState({activeTab: tabs[0], dashboards: tabs}); 
        }
    }

    public renderTab = () => {
        const { activeTab } = this.state;
        
        switch (activeTab) {
            case "Super Admin":
                return (
                    <SuperAdminDashboard/>
                );
            case "Adjuster":
                return (
                    <AdjusterDashboard/>
                );
            case "Payroll":
                return (
                    <PayrollDashboard/>
                );
            case "Adjuster Scorecard":
                return (
                    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '500px' }}>
                        <Card className="shadow-sm border-0" style={{ maxWidth: '450px', borderRadius: '15px' }}>
                            <CardBody className="p-5 text-center">
                                <div 
                                    className="d-inline-flex align-items-center justify-content-center mb-4" 
                                    style={{ 
                                        width: '80px', 
                                        height: '80px', 
                                        backgroundColor: '#e7f0ff', 
                                        borderRadius: '12px' 
                                    }}
                                >
                                    <FaChartBar size={40} color="#0d6efd" />
                                </div>

                                <h3 className="fw-bold mb-2">Adjuster Performance Scorecard</h3>
                                <p className="text-muted mb-4">
                                    Access deep-dive adjuster metrics and quality scores in our standalone analytics suite.
                                </p>

                                <Button 
                                    color="primary" 
                                    size="lg" 
                                    block 
                                    className="py-3 font-weight-bold"
                                    onClick={async () => {
                                        try {
                                            // 1. Call the API using your secure request helper
                                            const response = await request({
                                                method: 'GET',
                                                url: 'dashboards/scorecard/launch'
                                            });

                                            if (response.status === 200 && response.data.url) {
                                                // 2. Open the URL returned by the server in a new tab
                                                window.open(response.data.url, '_blank');
                                            } else {
                                                console.error("Failed to retrieve launch URL", response);
                                                alert("Could not launch Scorecard. Please check your permissions.");
                                            }
                                        } catch (error) {
                                            console.error("Launch error:", error);
                                        }
                                    }} 
                                    style={{ borderRadius: '10px' }}
                                >
                                    Launch Dashboard <FaExternalLinkAlt size={14} className="ml-2" />
                                </Button>
                                
                                <div className="mt-4">
                                    <small className="text-uppercase font-weight-bold text-muted" style={{ letterSpacing: '1px' }}>
                                        Secured by Comtrack Identity
                                    </small>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                );
            default:
                return <div>No Dashbaords Available</div>;
        }
    }

    public render() {
        const { activeTab, dashboards } = this.state; 

        return (
            <div>
                <div style={{visibility: dashboards.length > 1 ? "visible" : "hidden"}}>
                    <PageHeader
                        activeTab={activeTab}
                        getTabName={this.handleTabs}
                        tabs={dashboards}
                    />
                </div>                
                {this.renderTab()}
            </div>
        );
    }
}

export default (Dashboard);
